export default "__VITE_ASSET__DdxQJnvc__"